import { render } from "./InformeRentabilidadOperarios.vue?vue&type=template&id=656b4f9e&scoped=true"
import script from "./InformeRentabilidadOperarios.vue?vue&type=script&lang=js"
export * from "./InformeRentabilidadOperarios.vue?vue&type=script&lang=js"

import "./InformeRentabilidadOperarios.vue?vue&type=style&index=0&id=656b4f9e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656b4f9e"]])

export default __exports__